module.exports = __webpack_public_path__ + "img/expertise_bg_effect.897cff69.png";